import { render } from "./FAQ.vue?vue&type=template&id=0955b692&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=0955b692&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0955b692"

export default script